<ng-template #content>
  <!-- The label keeps its box while loading so the tag never changes size. -->
  <span class="ai-tag__label">{{ label }}</span>
  <ui-svg-icon *ngIf="editable && caret && !loading" svgIcon="chevron-down" size="xsmall" class="ai-tag__caret"></ui-svg-icon>
</ng-template>

<button *ngIf="editable; else staticTag"
        type="button"
        [class]="hostClasses"
        [disabled]="disabled || loading"
        [attr.title]="tooltip || null"
        (click)="onClick($event)">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>

<ng-template #staticTag>
  <span [class]="hostClasses" [attr.title]="tooltip || null">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </span>
</ng-template>
